import { Fragment } from "react";

import { PageContainer, SpinnerCenter } from "@shapr3d/frontend-lib";
import { useParams } from "react-router-dom";

import CTARow from "../components/CTARow/CTARow";
import { CTARowDivider } from "../components/CTARowDivider/CTARowDivider";
import { PurchaseNotice } from "../components/PurchaseNotice/PurchaseNotice";
import { IndividualSubscriptionInfo } from "../components/TeamSubscriptions/IndividualSubscriptionInfo/IndividualSubscriptionInfo";
import { SeatBasedSubscriptionInfo } from "../components/TeamSubscriptions/SeatBasedSubscriptionInfo/SeatBasedSubscriptionInfo";
import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";
import { usePrefetchPriceConfig } from "../hooks/usePriceConfig";
import { useTeamSubscriptions } from "../hooks/useTeams";

const TeamSubscriptionPage = () => {
  usePrefetchPriceConfig();

  const { teamID } = useParams();

  const { data: teamSubscriptionData, isLoading } = useTeamSubscriptions(teamID);

  if (isLoading || !teamSubscriptionData || !teamID) {
    return <SpinnerCenter />;
  }

  return (
    <UnderMaintenanceOrChildren>
      <PageContainer title="Subscription">
        {!teamSubscriptionData.creditBasedTeamSubscription &&
          !teamSubscriptionData.seatBasedTeamSubscription &&
          !teamSubscriptionData.individualSubscriptions && (
            <>
              <CTARow title="Subscription" text="Shapr3D Basic" />
              <CTARowDivider />
              <PurchaseNotice />
            </>
          )}

        {teamSubscriptionData.individualSubscriptions && (
          <>
            {teamSubscriptionData.individualSubscriptions.map((subscription) => (
              <Fragment key={subscription.id}>
                <IndividualSubscriptionInfo subscription={subscription} />
                <CTARowDivider />
              </Fragment>
            ))}
          </>
        )}

        {teamSubscriptionData.seatBasedTeamSubscription && (
          <SeatBasedSubscriptionInfo
            subscription={teamSubscriptionData.seatBasedTeamSubscription}
            teamID={teamID}
          />
        )}

        {teamSubscriptionData.creditBasedTeamSubscription &&
          // NOTE: We are not rendering it yet, since they are only members of the team, and currently we are only showing the members page for them
          null}
      </PageContainer>
    </UnderMaintenanceOrChildren>
  );
};

export default TeamSubscriptionPage;
